import "./App.css";
import { useState, useEffect } from "react";

import logo from "./images/araslogo-removebg-preview.png";
import a1 from "./images/a1.jpeg";
import a2 from "./images/a2.jpeg";
import a3 from "./images/a3.jpeg";
import a4 from "./images/a4.jpeg";
import a5 from "./images/a5.jpeg";
import a6 from "./images/a6.jpeg";
import a7 from "./images/a7.jpeg";
import a8 from "./images/a8.jpeg";
import a9 from "./images/a9.jpeg";
import a10 from "./images/a10.jpeg";
import a11 from "./images/a11.jpeg";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [slide, setSlide] = useState(0);
  const slides = [a1, a2, a3, a4, a5,a6,a7,a8,a9,a10,a11];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <div className="App">

      {/* NAVBAR */}
      <nav className="navbar">
        <div onClick={scrollTop}>
          <img src={logo} className="main-logo" alt="Aras Oto Kurtarma" />
        </div>

        <ul className={menuOpen ? "menu active" : "menu"}>
          <li><a href="#about">Hakkımızda</a></li>
          <li><a href="#location">Konum</a></li>
          <li><a href="#reviews">Yorumlar</a></li>
          <li><a href="#contact">İletişim</a></li>
        </ul>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? "✕" : "☰"}
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-slider">
          {slides.map((img, i) => (
            <img
              key={i}
              src={img}
              className={`slide ${i === slide ? "active" : ""}`}
              alt={`Slide ${i}`}
            />
          ))}
        </div>
        <div className="overlay"></div>
        <div className="hero-text">
          <h1>Aras Oto Kurtarma</h1>
          <p>Kırıkkale Merkez'den Türkiye'nin tüm illerine 7/24 çekici ve yol yardım hizmeti</p>
          <div className="hero-btns">
            <a href="tel:05071981553" className="btn-call">📞 Hemen Ara</a>
          </div>
        </div>
      </section>

      {/* HAKKIMIZDA */}
      <section id="about" className="section">
        <h2>Hakkımızda</h2>
       <p>
<b>Aras Oto Kurtarma</b> olarak Kırıkkale Yahşihan merkezli işletmemizle 
7 gün 24 saat kesintisiz çekici ve yol yardım hizmeti sunuyoruz. 
Yolda kaldığınız her an hızlı, güvenilir ve profesyonel çözümler üretmek 
önceliğimizdir.

Sabit kasa, kayar kasa, ağır makine taşıma ve vinç araçlarımızdan oluşan 
güçlü filomuz ile yalnızca Kırıkkale’de değil Türkiye’nin 81 ilinde 
araç taşıma ve kurtarma hizmeti sağlamaktayız. Deneyimli ekibimiz ve 
modern ekipmanlarımız sayesinde aracınızı güvenle istediğiniz noktaya 
ulaştırıyor, yolculuğunuza güvenle devam etmenizi sağlıyoruz.

<b>Aras Oto Kurtarma</b> – Yolda kaldığınız her an yanınızdayız.
</p>
      </section>

{/* KONUM */}
<section id="location" className="section">
  <h2>Konum</h2>
  <p>📍 Cumhuriyet Cad., No:303, Yahşihan, Kırıkkale</p>

  <div className="map-container">
    <iframe
      title="Aras Oto Kurtarma Konum"
      src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d6141.3921046691785!2d33.467028719464956!3d39.84186327879768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMznCsDUwJzI4LjciTiAzM8KwMjgnMDQuNCJF!5e0!3m2!1str!2str!4v1773256837142!5m2!1str!2str"
      width="100%"
      height="400"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</section>

      {/* YORUMLAR */}
      <section id="reviews" className="section">
        <h2>Müşteri Yorumları</h2>
        <div className="reviews">
          <div className="card">
            <p>"Gece 2'de aradım 20 dakikada geldiler."</p>
            <b>- Ahmet K.</b>
          </div>
          <div className="card">
            <p>"Kırıkkale'de yolda kalmıştım çok hızlı geldiler."</p>
            <b>- Mehmet T.</b>
          </div>
        </div>
        <a
          className="google-btn"
          href="https://www.google.com/search?q=aras+oto+kurtarma+kırıkkale"
          target="_blank"
          rel="noreferrer"
        >
          ⭐ Google'da Yorum Yap
        </a>
      </section>

      {/* FOOTER */}
      <footer id="contact">
        <img src={logo} className="footer-logo" alt="Aras Oto Kurtarma" />
        <h3>Aras Oto Kurtarma</h3>
        <p>📍 Yahşihan / Kırıkkale</p>
        <a href="tel:05071981553" className="phone">📞 0507 198 15 53</a>
        <a href="https://instagram.com/arasotokurtarma71" target="_blank" className="insta">
          📷 Instagram: arasotokurtarma71
        </a>
        <p className="copy">© 2026 Aras Oto Kurtarma</p>
      </footer>

      {/* SABİT BUTONLAR */}
      <a href="tel:05071981553" className="call">📞</a>
      <a href="https://wa.me/905071981553" className="wp">💬</a>

    </div>
  );
}

export default App;